import * as ActionTypes from '../actionTypes';

const initialState = {
    data: [],
    isResetData: true,
    nextToken: null,
    cntNewAlert: 0,
};

export default function reducer(state = initialState, action) {
    let object;
    switch (action.type) {
        case ActionTypes.STARTING_MARK_SEEN_ALERT:
            object = {
                cntNewAlert: 0,
            };
            return { ...state, ...object };
        case ActionTypes.STARTING_GET_ALERT_LIST:
            object = {
                isResetData: !action.nextToken,
            };
            return { ...state, ...object };
        case ActionTypes.COMPLETE_GET_ALERT_LIST:
            object = {
                data: action.payload,
                nextToken: action.nextToken,
            };
            if (!action.preToken) {
                if (action.payload.length > 0) {
                    object.cntNewAlert = action.payload.filter((item) => item.isNew).length;
                }
            }
            return { ...state, ...object };
        default:
            return state;
    }
}
